module.exports = __webpack_public_path__ + "img/mw.a740819b.svg";